import { withInstall } from '@jtis/vue-components'
import Icon from './src/Icon.vue'
import './style/index.scss'

export const JtIcon = withInstall(Icon)

export default JtIcon
